import { GetCrecaTradesHistoryApi } from "@/features/accounts/creca/services/get-trades-history-api";
import { GetCrecaTradesHistoryRequestModel } from "@/features/accounts/creca/services/get-trades-history-model";

/// クレカ取込履歴取得処理
export class GetCrecaTradesHistoryService {
  private getCrecaTradesHistoryApi = new GetCrecaTradesHistoryApi();

  /**
   * クレカ取込履歴取得API実行
   */
  public async getCrecaTradesHistory(param: GetCrecaTradesHistoryRequestModel) {
    return await this.getCrecaTradesHistoryApi.getCrecaTradesHistory(param);
  }
}
